document.addEventListener('DOMContentLoaded', function() {
  // map init
	const mapContainer = document.getElementById('mapBody');
	let map;

	ymaps.ready(init);

	function init(){
		var myMap = new ymaps.Map(mapContainer, {
			center: [60.006934, 30.436683],
			zoom: 15,
			controls: ['zoomControl']
		});

		myMap.behaviors.disable('scrollZoom');

		var mark = new ymaps.Placemark(myMap.getCenter(), {
			hintContent: 'Hisun',
			balloonContent: 'Компания Классика'
		},
		{
			iconLayout: 'default#image',
			iconImageHref: 'img/map-marker.svg',
			iconImageSize: [22.5, 30],
			iconImageOffset: [-5, -38]
		}

		);
		myMap.geoObjects.add(mark);
	};
});